package com.bikompanion.data

import kotlinx.serialization.Serializable

/** Where `out center` puts the middle of a way or relation, since it has no position of its own. */
@Serializable
internal data class OverpassCenter(
    val lat: Double,
    val lon: Double,
)
